import isNumber from 'lodash/isNumber';
import { pluralizeWord } from 'modules/campaigns/lib/utils';
import { MessageCategory } from 'modules/dragAndDropEditor/types';
import { useMemo } from 'react';

export const useCategoriesRowCountTextsMapper = (messageCategories: MessageCategory[]) => {
  const rowCountsMapper = useMemo(
    () =>
      messageCategories.reduce(
        (mapper, category) => {
          const { rowsCount } = category;
          const rowSuffix = isNumber(rowsCount)
            ? `${rowsCount} ${pluralizeWord('row', rowsCount)}`
            : '';

          return { ...mapper, [category.name]: rowSuffix } as const;
        },
        {} as Record<string, string>,
      ),
    [messageCategories],
  );

  return rowCountsMapper;
};
